import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common';
export var cardKey = 'card';
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    Card.prototype.render = function () {
        var props = this.props;
        var type = props.type || 'type-a';
        var classNames = namespacedClassnames(cardKey, props.className, type);
        return (React.createElement("div", { className: classNames }, props.children));
    };
    return Card;
}(React.PureComponent));
export { Card };
export * from './card-header';
export * from './card-section';
//# sourceMappingURL=index.js.map